<script>
  import CustomPackage from "./CustomPackage.svelte";

  let mode = "init"; //init, editing, building, ready, filtering, buying
  $: console.log(mode);

// TODO: Change modals to context or store.
  let modals = [];

  const placeholderPhrase = "YOUR PHRASE\nHERE";
  let oldPhrase;
  let phrase = placeholderPhrase;

  let customPackages = [];
  $: customPackagesFiltered = customPackages
    .filter(x => (selectedColor == "All" ? true : selectedColor == x.color))
    .filter(y =>
      selectedStyle == "All" ? true : selectedStyle.includes(y.style)
    );

  //TODO: Have fonts send font style (block, script).
  //For now just determine style based on size in makeCustomPackages.
  //TODO: Pass a scaler into CustomPackage, which is the height of the largest font.
  //TODO: Download fonts one at a time and display them as they become ready.
  let fonts;

  //TODO: Make packages for styles+colors that become unfiltered
  //if packages were made while filters were applied.
  let selectedColor;
  let selectedStyle;
  let fontColors = ["All"]; //Will be populated with font colors once fonts download
  let fontStyles = ["All", 'Jumbo 34″', 'Script 24″', 'Standard 14″'];
  let customizeWaiting = false; //true if Customize button clicked.

  //TODO: Handle fonts fail to download.
  async function fetchFonts() {
    //TODO: throw up modals/change customize button while waiting for fonts to download
	modals = [{message: "Loading balloon styles..."}];
    const res = await fetch(
      `https://www.instaballoons.com/pages/letter-number-metadata`
    );
	modals = [];
    const mfonts = await res.json();
    fonts = mfonts.fonts;
    fontColors = Array.from(
      new Set(fontColors.concat(fonts.map(x => x.colors).flat()))
    );
    if (customizeWaiting) {
      build();
    } else {
      mode = "ready";
    }
  }

  //Clear placeholer text from textarea on click
  //And restore placeholder text on blur if text
  //was not changed.
  function textareaClick() {
    if (oldPhrase == null && phrase == placeholderPhrase) {
      phrase = "";
    }
  }
  function textareaBlur() {
    if (phrase.trim() == "") {
      phrase = placeholderPhrase;
    }
  }

  //TODO: Disable while mode == init.
  //TODO: Show please wait if clicked while init.
  function customizeClick() {
    //If this is the first click, fonts will need to be downloaded.
    //Set customizeWaiting (font download will then automatically
    //call build(). Otherwise, go straight to build.
    if (!fonts) {
      console.log("Waiting for fonts to download.");
      fetchFonts();
      customizeWaiting = true;
    } else {
      if (mode != "editing") {
        mode = "editing";
      } else {
        build();
      }
    }
  }

  function build() {
    customizeWaiting = false;
    mode = "building";
    oldPhrase = phrase;
    makeCustomPackages();
  }

  /** Split text into rows of words. */
  function parsePhrase(phrase) {
    phrase = phrase.split(/^/m);
    phrase = phrase.map(x => x.trim());
    phrase = phrase.map(x => x.split(/\s+/));
    phrase = phrase.filter(x => x != "");
    return phrase;
  }

  /** Create an image, price, etc. for each font using the provided phrase. */
  //TODO: Don't blindly make packages for filtered-out options,
  //but do make the packages if that filter gets removed.
  function makeCustomPackages() {
    if (mode == "init") {
      customizeWaiting = true;
      return;
    }
    customizeWaiting = false;
    let parsedPhrase = parsePhrase(phrase);
    customPackages = [];
    for (let font of fonts) {
      for (let color of font.colors) {
        let customPackage = {
          //parsedPhrase: parsedPhrase,
          color: color,
          style: "Standard",
          variants: [],
          closeout: false
        };
        if (font.handle.indexOf("closeout") > -1) {
          customPackage.closeout = true;
        }
        if (font.size > 30) {
          customPackage.style = "Jumbo";
        }
        if (font.size == 24) {
          customPackage.style = "Script";
        }
        customPackage.price = 0;
        for (let row of parsedPhrase) {
          let rowArray = [];
          for (let word of row) {
            let wordArray = [];
            for (let letter of word) {
              //Choose the variant that matches letter we're on and the font color
              //we're currently building the package for. Remember some fonts have
              //multiple colors (i.e., they are not separate products based on color).
              let variant = font.variants.filter(
                x =>
                  x.letter.toUpperCase() == letter.toUpperCase() &&
                  x.color == color
              )[0];
              //If letter doesn't exist in this font, variant will be undefined.
              if (typeof variant !== "undefined") {
                wordArray.push(variant);
                customPackage.price += variant.price;
              }
            }
            //Words are ignored if made up entirely of characters missing from the font.
            if (wordArray.length > 0) {
              rowArray.push(wordArray);
            }
          }
          //Row is ignored if none of the characters exist in font.
          if (rowArray.length > 0) {
            customPackage.variants.push(rowArray);
          }
        }
        //Don't add this customPackage to the list if it's blank!
        //(Can happen if none of the letters from the phrase exist in the font.)
        if (customPackage.variants.flat(2).length > 0) {
          customPackages = [...customPackages, customPackage];
        }
      }
    }
    mode = "ready";
  }

  mode = "ready";

  $: if (mode != "init" && phrase != oldPhrase) {
    mode = "editing";
  }
</script>

<style>
  .ibcustomizer-container {
    /* background-color: blue; */
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    padding: 1em;
    margin: 0 auto;
  }
  .custom-packages {
    max-height: 80vh;
    overflow-y: scroll;
  }
  .spin {
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  textarea {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 700;
  }
  h1 {
    /* color: #ff3e00; */
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }
  .modals-background {
    position: fixed;
    z-index: 99;
    width: 100%;
    text-align: center;
    height: 50vh;
	left: 0;
	top: 0;
  }
  .modals-foreground {
    position: relative;
    top: 10%;
    left: 10%;
    width: 80%;
    height: 80%;
    background-color: white;
    border: 1vw solid #2e2644;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* .modals-message {
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  } */
</style>

<div class="ibcustomizer-container">
  {#each modals as modal}
    <div class="modals-background">
      <div class="modals-foreground">
        <div class="modals-message">{modal.message}</div>
      </div>
    </div>
  {/each}
  <textarea
    bind:value={phrase}
    on:click={textareaClick}
    on:blur={textareaBlur} />
  <br />
  {#if phrase != oldPhrase && phrase.trim() != ''}
    <button on:click={customizeClick} style="cursor: progress">
      <!-- {#if false} -->
      Customize
      <!-- {:else}
        <img class="spin" src="circle-notch-solid.svg" width="25" height="25" />
      {/if} -->
    </button>
  {/if}
  {#if customPackages.length}
    <div>
      Style:
      <select bind:value={selectedStyle}>
        {#each fontStyles as fontStyle}
          <option value={fontStyle}>{fontStyle}</option>
        {/each}
      </select>
      Color:
      <select bind:value={selectedColor}>
        {#each fontColors as fontColor}
          <option value={fontColor}>{fontColor}</option>
        {/each}
      </select>
    </div>
    <!-- TODO: Only want to hide/show custom packages when filters change,
	but will these remount each one, causing the canvas to be regenerated? -->
    <div class="custom-packages">
      {#each customPackagesFiltered as cp}
        <CustomPackage {...cp} bind:modals />
      {:else}
        Nothing to display!
        <br />
        Try applying fewer filters.
      {/each}
    </div>
  {/if}
</div>
